// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAYCAYAAACMcW/9AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACnSURBVHgBzdfJDcAgDARAd04JlOASKYEEEn8SQjh8rWSJB2JHiA8AV8I56Z4I9ml6yiI/BsEuCG9PgVd1Bh9Y/LCkHlQbix1HhYbOBi0s/hji6EZJ7HS3BXa5UxO73aWBZeuQxLKfLYEVuwDOg8WfFEeBOJKjSA25U6iOXCk2Q84AzJGjWBfIHaw6kjKDNUNSRrDmSEoP6wZJaWHdISnly0Df3ACMOQATckHecQwCXQAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.stagesTableDiv tr> td{
    border-right: 1px solid #DCDCDC !important;
    border-collapse: collapse !important;
    padding:0 !important;
  }
.stagesTableDiv td{
    min-width: 250px;
    max-width: 250px;
    height:50px;
    vertical-align: top !important;
  }
  .scheduleInput{
    margin-right: 10px;
    border-radius: 4px; 
    height:40px;
    width:180px;
}
.draggableItem {
  height: 50px;
  border-bottom: 1px solid #DCDCDC;
  min-width: 250px;
  max-width: 250px;
  display: flex;
  align-items: center;
}

.dragging{
  border:1px solid  #DCDCDC;
}

[data-rbd-droppable-context-id] {
  min-height: 200px;
  overflow: scroll;
  max-height: 400px;
}
.stickyFirst{
  position: sticky;
  top:0;
  background-color: white;
  border-right:1px solid #DCDCDC;
}

.stickySecond{
  position: sticky;
  top:50px;
  background-color: white;
  border-right:1px solid #DCDCDC;
}
.otherColumnCompName,.otherColumnCompCount,.eventsCompClass{
border-right:1px solid #DCDCDC;
height:100%;
display:flex;
align-items: center;
justify-content: center;
font-size: 12px;
}
.otherColumnCompName{
  width:50px;
  position: relative;
}
.eventsCompClass{
  width:125px;
font-size: 14px;

}
.eventsCompCount{
  width:100px;
  height:100%;
  display:flex;
  align-items: center;
  justify-content: center;
font-size: 14px;
}
.hoverOverlay{
  position: absolute;
  top: 0;
  right: 0;
  width:100%;
  height: 100%;
  font-size: 19px;
  background-color: rgba(255, 0, 0, 0.5); /* Translucent red color */
  color: white; /* Text color of the crossmark */
  padding: 20% 40%;
  display: none; /* Initially hidden */
}
.otherColumnCompName:hover .hoverOverlay{
  display:block;
}
.breakTimeDiv:hover .hoverOverlay{
  display:block;
  padding:10% 40%;
}
.otherColumnCompCount{
  width: 40px;
}
.otherColumnTime,.breakTimeDiv{
  font-size: 12px;
  display:flex;
align-items: center;
justify-content: center;
width:121px; 
flex-grow: 1;
height:100%;
position:relative;
}
.breakTimeDiv{
  width:50%;
}


/* time picker css */
.rc-time-picker-panel {
  z-index: 10070 !important;
}

.rc-time-picker-panel-select {
  font-size: 14px !important;
  max-height: 104px !important;
  border:none !important;
}
.rc-time-picker-panel-inner{
  width:102px !important;
}

.rc-time-picker-input,.time-setter-input,.time-setter-modal-select {
  width: 102px !important;
  height:40px !important;
  border:1px solid #797979 !important;
  border-radius: 4px !important;
  padding:4px;
  font-size: 12px;
}
.rc-time-picker-panel-select {
  width:34px !important
}
.rc-time-picker-panel-select li {
  padding:4px !important;
  height:25px !important
}
.rc-time-picker-input:focus-visible{
  outline: none !important;
}
.rc-time-picker-clear{
  display:none !important;
}
.rc-time-picker-input:focus-visible,.time-setter-input:focus-visible{
  outline:none !important;
}
.time-setter-modal-select{
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 10%;
  background-position: top 50% right 8%;
}
`, "",{"version":3,"sources":["webpack://./src/Organizer/ManageFeisGrade/RedirectFeis/Schedule/schedule.css"],"names":[],"mappings":";AACA;IACI,0CAA0C;IAC1C,oCAAoC;IACpC,oBAAoB;EACtB;AACF;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;AACA;EACE,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,KAAK;EACL,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,uBAAuB;EACvB,8BAA8B;AAChC;AACA;AACA,8BAA8B;AAC9B,WAAW;AACX,YAAY;AACZ,mBAAmB;AACnB,uBAAuB;AACvB,eAAe;AACf;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,WAAW;AACb,eAAe;;AAEf;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB,eAAe;AACf;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,eAAe;EACf,sCAAsC,EAAE,0BAA0B;EAClE,YAAY,EAAE,gCAAgC;EAC9C,gBAAgB;EAChB,aAAa,EAAE,qBAAqB;AACtC;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,YAAY;AACd,mBAAmB;AACnB,uBAAuB;AACvB,WAAW;AACX,YAAY;AACZ,WAAW;AACX,iBAAiB;AACjB;AACA;EACE,SAAS;AACX;;;AAGA,oBAAoB;AACpB;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,mCAAmC;EACnC,6BAA6B;EAC7B,WAAW;EACX,eAAe;AACjB;AACA;EACE;AACF;AACA;EACE,sBAAsB;EACtB;AACF;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,yDAA6Z;EAC7Z,4BAA4B;EAC5B,oBAAoB;EACpB,qCAAqC;AACvC","sourcesContent":["\n.stagesTableDiv tr> td{\n    border-right: 1px solid #DCDCDC !important;\n    border-collapse: collapse !important;\n    padding:0 !important;\n  }\n.stagesTableDiv td{\n    min-width: 250px;\n    max-width: 250px;\n    height:50px;\n    vertical-align: top !important;\n  }\n  .scheduleInput{\n    margin-right: 10px;\n    border-radius: 4px; \n    height:40px;\n    width:180px;\n}\n.draggableItem {\n  height: 50px;\n  border-bottom: 1px solid #DCDCDC;\n  min-width: 250px;\n  max-width: 250px;\n  display: flex;\n  align-items: center;\n}\n\n.dragging{\n  border:1px solid  #DCDCDC;\n}\n\n[data-rbd-droppable-context-id] {\n  min-height: 200px;\n  overflow: scroll;\n  max-height: 400px;\n}\n.stickyFirst{\n  position: sticky;\n  top:0;\n  background-color: white;\n  border-right:1px solid #DCDCDC;\n}\n\n.stickySecond{\n  position: sticky;\n  top:50px;\n  background-color: white;\n  border-right:1px solid #DCDCDC;\n}\n.otherColumnCompName,.otherColumnCompCount,.eventsCompClass{\nborder-right:1px solid #DCDCDC;\nheight:100%;\ndisplay:flex;\nalign-items: center;\njustify-content: center;\nfont-size: 12px;\n}\n.otherColumnCompName{\n  width:50px;\n  position: relative;\n}\n.eventsCompClass{\n  width:125px;\nfont-size: 14px;\n\n}\n.eventsCompCount{\n  width:100px;\n  height:100%;\n  display:flex;\n  align-items: center;\n  justify-content: center;\nfont-size: 14px;\n}\n.hoverOverlay{\n  position: absolute;\n  top: 0;\n  right: 0;\n  width:100%;\n  height: 100%;\n  font-size: 19px;\n  background-color: rgba(255, 0, 0, 0.5); /* Translucent red color */\n  color: white; /* Text color of the crossmark */\n  padding: 20% 40%;\n  display: none; /* Initially hidden */\n}\n.otherColumnCompName:hover .hoverOverlay{\n  display:block;\n}\n.breakTimeDiv:hover .hoverOverlay{\n  display:block;\n  padding:10% 40%;\n}\n.otherColumnCompCount{\n  width: 40px;\n}\n.otherColumnTime,.breakTimeDiv{\n  font-size: 12px;\n  display:flex;\nalign-items: center;\njustify-content: center;\nwidth:121px; \nflex-grow: 1;\nheight:100%;\nposition:relative;\n}\n.breakTimeDiv{\n  width:50%;\n}\n\n\n/* time picker css */\n.rc-time-picker-panel {\n  z-index: 10070 !important;\n}\n\n.rc-time-picker-panel-select {\n  font-size: 14px !important;\n  max-height: 104px !important;\n  border:none !important;\n}\n.rc-time-picker-panel-inner{\n  width:102px !important;\n}\n\n.rc-time-picker-input,.time-setter-input,.time-setter-modal-select {\n  width: 102px !important;\n  height:40px !important;\n  border:1px solid #797979 !important;\n  border-radius: 4px !important;\n  padding:4px;\n  font-size: 12px;\n}\n.rc-time-picker-panel-select {\n  width:34px !important\n}\n.rc-time-picker-panel-select li {\n  padding:4px !important;\n  height:25px !important\n}\n.rc-time-picker-input:focus-visible{\n  outline: none !important;\n}\n.rc-time-picker-clear{\n  display:none !important;\n}\n.rc-time-picker-input:focus-visible,.time-setter-input:focus-visible{\n  outline:none !important;\n}\n.time-setter-modal-select{\n  -webkit-appearance: none;\n  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAYCAYAAACMcW/9AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACnSURBVHgBzdfJDcAgDARAd04JlOASKYEEEn8SQjh8rWSJB2JHiA8AV8I56Z4I9ml6yiI/BsEuCG9PgVd1Bh9Y/LCkHlQbix1HhYbOBi0s/hji6EZJ7HS3BXa5UxO73aWBZeuQxLKfLYEVuwDOg8WfFEeBOJKjSA25U6iOXCk2Q84AzJGjWBfIHaw6kjKDNUNSRrDmSEoP6wZJaWHdISnly0Df3ACMOQATckHecQwCXQAAAABJRU5ErkJggg==);\n  background-repeat: no-repeat;\n  background-size: 10%;\n  background-position: top 50% right 8%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
